import { useContext } from "react";
import { AuthContext } from "./contexts/AuthContext";
import { WorkspaceContext } from "./contexts/WorkspaceContext";
import Spinner from "./components/Spinner";
import SigninPage from "./pages/SigninPage";
import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <Spinner visibility={loading} />;

  if (!user) return <SigninPage />;

  return children;
};

export const WorkspaceRequired = ({ children }) => {
  const { currentWorkspace, loading } = useContext(WorkspaceContext);
  const location = useLocation();

  if (loading) return <Spinner visibility={loading} />;

  if (!currentWorkspace) {
    return <Navigate to="/workspaces" state={{ from: location }} replace />;
  }

  return children;
};

export const WorkspacePermission = ({ permission, children }) => {
  const { hasPermission } = useContext(WorkspaceContext);

  if (!hasPermission(permission)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export const GuestRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <Spinner visibility={loading} />;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return children;
};
